module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_8011.4a1ff475.png";